import { render } from "./CourseList.component.vue?vue&type=template&id=93784edc&ts=true"
import script from "./CourseList.component.vue?vue&type=script&lang=ts"
export * from "./CourseList.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__